import { apiFetch } from "./client";

export interface SendPayload {
  to: string | string[];
  from: string;
  replyTo?: string;
  subject?: string;
  html?: string;
  text?: string;
  templateId?: string;
  variables?: Record<string, string | number | boolean>;
  tags?: string[];
}

export interface SendResult {
  messageId: string;
  provider: "brevo" | "resend";
  providerMessageId: string | null;
  logsUrl?: string;
}

export const sendApi = {
  send: (payload: SendPayload) =>
    apiFetch<SendResult>("/admin/send", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};
